export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/aboutUsAr.93c3e428.svg","height":374,"width":1440,"blurWidth":0,"blurHeight":0};